export type TriggerKey = 'overdueamount' | 'payment_reminder' | 'dsc_expiry_reminder';

export const triggerTemplateConfig: Record<TriggerKey, {
  title: string;
  subject: string;
  content: string;
  variables: string[];
}> = {
  overdueamount: {
    title: "Outstanding Payment Reminder",
    subject: "Reminder: Payment Due",
    content: `
      Hi <B>{{display_name}}</B>,<br/><br/>
      You have an outstanding balance of ₹<B>{{dueamount}}</B>.<br/>
      `,
    variables: ['display_name', 'dueamount']
  },
  payment_reminder: {
    title: "Payment Reminder for Invoice ",
    subject: "Payment Reminder for Invoice",
    content: `
Dear <B>{{clientname_clientgroupname}} </B>,<br></br>

This is a friendly reminder regarding your invoice for our professional services.<br></br>
According to our records, we have an outstanding payment on Invoice #{{invoicenumber}},which was issued on {{invoicedate}} <br></br>

Invoice Summary:<br></br>

Invoice Number - {{invoicenumber}}<br></br>
Issue Date	   - {{invoicedate}}<br></br>
Total Amount	 -     ₹{{invoiceamount}}<br></br>
Amount Paid	   -         ₹{{amountrecieved}}<br></br>
Outstanding Balance	-     ₹{{balancedueamount}}<br></br>

To clear the outstanding balance of ₹{{balancedueamount}}, you can make the payment.<br></br>

If you have already processed this payment, please ignore this email.<br></br>

Thank you for your prompt attention.
    `,
    variables: ['clientname_clientgroupname','invoicenumber','invoicedate','invoicenumber','invoicedate','invoiceamount','amountrecieved','balancedueamount','balancedueamount']
  },
  dsc_expiry_reminder: {
    title: "Your DSC is Expiring Soon",
    subject: "Your DSC is Expiring Soon",
    content: `
     Dear {{holderName}},<br></br>
This is an important alert regarding the Digital Signature Certificate (DSC) for {{holderName}}.<br></br>
Our records indicate that this DSC is set to expire on {{expiryDate}}.<br></br>
To ensure seamless and uninterrupted e-filing for your statutory compliances, we recommend initiating the renewal process immediately.<br></br>
Please provide us with the necessary documents so we can assist you with the renewal.<br></br>

Thank you,
    `,
    variables: ['holderName','holderName', 'expiryDate']
  }
};
